import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { Auth } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild {

  constructor(private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot,
            state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {

	return Auth.currentAuthenticatedUser()
	.then(user => {
		return true;
	})
	.catch(error => {
		// Preserve the full URL (including query parameters) as returnUrl
		const returnUrl = state.url;
		this.router.navigate(['/login'], {
			queryParams: { returnUrl: returnUrl }
		});
		return false;
	});
  }

  canActivateChild(route: ActivatedRouteSnapshot,
					state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		return this.canActivate(route, state);
	}
}
